var getTypeName = require('./getTypeName');

function getDefaultInterfaceName(props) {
  return '{' + Object.keys(props).map(function (prop) {
    return prop + ': ' + getTypeName(props[prop]);
  }).join(', ') + '}';
}

module.exports = getDefaultInterfaceName;



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/getDefaultInterfaceName.js
 ** module id = 106
 ** module chunks = 0
 **/